const isDevelopment = import.meta.env.DEV || import.meta.env.MODE === 'development';

export const logger = {
	info: (message: string, ...args: unknown[]) => {
		if (isDevelopment || import.meta.env.MODE === 'development') {
			console.info(`[INFO] ${message}`, ...args);
		}
	},
	error: (message: string, ...args: unknown[]) => {
		// Always log errors, even in production
		console.error(`[ERROR] ${message}`, ...args);
	},
	warn: (message: string, ...args: unknown[]) => {
		if (isDevelopment || import.meta.env.MODE === 'development') {
			console.warn(`[WARN] ${message}`, ...args);
		}
	},
	debug: (message: string, ...args: unknown[]) => {
		if (isDevelopment || import.meta.env.MODE === 'development') {
			console.debug(`[DEBUG] ${message}`, ...args);
		}
	},
	log: (message: string, ...args: unknown[]) => {
		if (isDevelopment || import.meta.env.MODE === 'development') {
			console.log(`[LOG] ${message}`, ...args);
		}
	},
};
